import { useTheme } from "@mui/material"

import { useTranslation } from "providers/i18n"

import { FullScreenOverlayLayout } from "layouts/FullScreenOverlayLayout"

import { Head } from "components/Head"

export const HomePage = () => {
  const theme = useTheme()
  const { t } = useTranslation()

  const { root } = theme.components[`HomePage`]?.styleOverrides || {}

  return (
    <>
      <Head title={t("Home")} />
      <FullScreenOverlayLayout sx={root}>Home</FullScreenOverlayLayout>
    </>
  )
}
